/**
 * Canvas-only styles for the structural grid table inside a layout.
 * Visual layout chrome (background, border, padding) is on the inner layout wrapper.
 */
export const layoutGridTableCanvasSx = {
  width: "100%",
  height: "100%",
  borderCollapse: "collapse",
  tableLayout: "fixed",
};

export const layoutGridRowCanvasSx = {
  height: "1px",
};

export const nestedLayoutBlockCanvasSx = {
  mb: 0,
  flex: "1 1 auto",
  minHeight: 0,
  height: "100%",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignSelf: "stretch",
};

export const nestedLayoutInnerCanvasSx = {
  flex: "1 1 auto",
  minHeight: 0,
  height: "100%",
  display: "flex",
  flexDirection: "column",
};
 